import { getChartType } from '../core/chart-model-utils';
import { ChartType } from '../types';
export class MobileHighchartConfig {
    constructor(chartModel) {
        this._chartModel = chartModel;
        this._highchartConfig = {
            plotOptions: {
                series: {},
                column: {},
            },
        };
    }
    setScatterChartOverrides() {
        const chartType = getChartType(this._chartModel);
        if (chartType === ChartType.Scatter) {
            this._highchartConfig.plotOptions.series.stickyTracking = true;
        }
        return this;
    }
    dropGraySelected() {
        this._highchartConfig.plotOptions.column.allowPointSelect = false;
        return this;
    }
}
//# sourceMappingURL=mobile-highchart-config.js.map